"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebNotification = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _interweave = require("interweave");

var _reactIntersectionVisible = _interopRequireDefault(require("react-intersection-visible"));

var _StackedAvatars = require("../../StackedAvatars");

var _NotificationIcon = require("../NotificationIcon");

var _NotificationAction = require("../NotificationAction");

var _atoms = require("../../../atoms");

require("./WebNotification.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var WebNotification = function WebNotification(_ref) {
  var _notification$message, _notification$message2;

  var notification = _ref.notification,
      onNotificationClick = _ref.onNotificationClick,
      onActionClick = _ref.onActionClick,
      setViewed = _ref.setViewed;

  var onClick = function onClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (typeof onNotificationClick === "function") {
      onNotificationClick(e);
    }
  };

  (0, _react.useLayoutEffect)(function () {
    var elements = document.getElementsByClassName("web-notification");

    for (var i = 0; i < elements.length; i++) {
      var aTags = elements[i].getElementsByTagName("a");

      if (aTags.length) {
        for (var j = 0; j < aTags.length; j++) {
          elements[i].getElementsByTagName("a")[j].addEventListener("click", function (event) {
            event.stopImmediatePropagation();
          });
        }
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactIntersectionVisible.default, {
    onShow: function onShow(e) {
      return setViewed(notification.msg_id);
    }
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    key: "notification-".concat(notification.msg_id),
    className: "web-notification ".concat(["coach_moments_added", "coach_time_watched", "player_time_watched", "player_moments_added", "user_engagement_celebration"].includes(notification.type) ? "web-notification-nonclickable" : ""),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "notification-circle ".concat(!!notification.delivery.date_read ? " viewed" : ""),
    marginRight: "2"
  }), !["user", "user_celebration"].includes(notification.message.group) && /*#__PURE__*/_react.default.createElement(_NotificationIcon.NotificationIcon, {
    group: notification.message.group
  }), notification.message.group === "user" && /*#__PURE__*/_react.default.createElement(_StackedAvatars.StackedAvatars, {
    users: notification === null || notification === void 0 ? void 0 : (_notification$message = notification.message) === null || _notification$message === void 0 ? void 0 : _notification$message.users.slice(0, 3)
  }), notification.type === "user_engagement_celebration" && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "notification-user-celebration-container"
  }, /*#__PURE__*/_react.default.createElement(_StackedAvatars.StackedAvatars, {
    size: 40,
    users: [notification === null || notification === void 0 ? void 0 : (_notification$message2 = notification.message) === null || _notification$message2 === void 0 ? void 0 : _notification$message2.users[0]],
    marginRight: "8"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "\uD83D\uDC4D",
    className: "notification-user-celebration",
    type: _atoms.Label.Type.Heading4
  })))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "web-notification-middle-content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: /*#__PURE__*/_react.default.createElement(_interweave.Markup, {
      content: notification.message.text
    }),
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Body
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "web-notification-side-info"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_NotificationAction.NotificationAction, {
    notification: notification,
    onActionClick: onActionClick
  })))));
};

exports.WebNotification = WebNotification;